// Typed RIASEC answers are scored the way the Dialogflow agent scored them: its own Yes and No
// training phrases (riasecAnswerWords.json, from AnnaChatbot.zip). "Sometimes", "a little",
// "depends" and "probably" count as Yes and "not sure" / "I don't know" as No, as the RIASEC
// answer rules intend. "Maybe" was trained as both; it is Yes on 41 of the 42 questions, so it is Yes.
import words from './riasecAnswerWords.json';

export const normalizeReply = (text) =>
  String(text || '')
    .toLowerCase()
    .replace(/[’‘`]/g, "'")
    .replace(/[“”"]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/[.,!?]+$/, '')
    .trim();

const YES = new Set(words.yes.map(normalizeReply));
const NO = new Set(words.no.map(normalizeReply));
YES.add('maybe');
NO.delete('maybe');

const YES_STARTS = ['yes', 'yeah', 'yup', 'yep', 'oo', 'opo', 'sure', 'definitely', 'syempre', 'gusto'];
const NO_STARTS = ['no', 'nope', 'nah', 'hindi', 'di', 'ayoko', 'ayaw', 'never', 'not', 'wala'];

/** 'yes', 'no', or null when the reply isn't clearly either (Anna asks again). */
export const matchAnswer = (text) => {
  const reply = normalizeReply(text);
  if (!reply) return null;
  if (YES.has(reply)) return 'yes';
  if (NO.has(reply)) return 'no';
  const first = reply.split(/[\s,]+/)[0];
  if (YES_STARTS.includes(first)) return 'yes';
  if (NO_STARTS.includes(first)) return 'no';
  return null;
};
